(function () {
	Vue.component('searchable-dropdown', {
		model: {
			prop: 'values',
			event: 'change'
		},
		template: `<div class="searchable-dropdown" :id="id">

    <div class="field is-grouped" v-if="items.length > 5">
    <div class="control field has-addons">
    <div class="control">
    <input class="input is-deep" type="text" name="search" v-model="searchOn" v-on:keyup="searchDropdown" />
    </div>
    <div class="control">
    <a id="search-button" class="button is-deep" v-on:click="searchDropdown">
    <span class="icon  is-small "><i aria-hidden="true" class="fa  fa-search"></i></span>
    </a>
    </div>
    </div>

    </div>

    <div class="field is-list searchable-dropdown-list" :class="{'is-megamenu': items.length > 5}">
    <div class="mui-field field control" v-if="items.length > 5">
    <label class="checkbox is-fullwidth">
    <input type="checkbox" @change="toggleCheckboxes" v-model="toggleState"/>
    <span class="bin"></span>
    <span class="subject" v-if="!toggleState">All visible</span>
    <span class="subject" v-if="toggleState">Clear visible</span>
    </label>
    </div>
    <div class="mui-field field control searchable-item" v-for="(vv, i) in items">
    <label class="checkbox is-fullwidth">
    <input type="checkbox" :value="vv.key" :data-text="vv.value" @change="updateValues"  v-model="selected" class="searchable-item-input"/>
    <span class="bin"></span>
    <span class="subject">{{vv.value}}</span>
    </label>
    </div>
    </div>

    </div>`,
		props: {
			id: {
				type: String,
				required: true,
				default: 'id'
			},
			items: {
				type: Array,
				required: true,
				default: () => []
			},
			values: {
				type: Array,
				required: false
			}
		},
		data: function () {
			return {
				searchOn: '',
				show: true,
				toggleState: false,
				selected: this.values || []
			};
		},
		watch: {
			values: function (val) {
				this.selected = val;
			}
		},
		methods: {
			searchDropdown: function () {
				const search = this.searchOn.toLowerCase();
				const lis = document.querySelectorAll(`#${this.id} .searchable-dropdown-list > div.searchable-item`);

				for (let i = 0; i < lis.length; i++) {
					const txt = lis[i].textContent.toLowerCase();
					if (!search || search.length == 0) {
						lis[i].classList.remove('is-hidden');
					} else if (txt.indexOf(search) > -1) {
						lis[i].classList.remove('is-hidden');
					} else {
						lis[i].classList.add('is-hidden');
					}
				}
			},
			updateValues: function () {
				const selItems = document.querySelectorAll(`#${this.id} .searchable-item-input[type="checkbox"]:checked`);
				if (selItems.length > 0) {
					this.selected = Array.prototype.map.call(selItems, it => it.value);
				} else {
					this.selected = [];
				}
				this.$emit('change', this.selected);
			},
			toggleCheckboxes: function (e) {
				if (e.target.checked) {
					/* Turn all visible boxes on */
					/* Get all boxes that are not hidden and not on */
					const boxes = $(`#${this.id} .searchable-item:not(".is-hidden") .searchable-item-input[type="checkbox"]:not(:checked)`);
					/* Now add them to this.values */
					for (let i = 0; i < boxes.length; i++) {
						this.selected.push(boxes[i].value);
					}
				} else {
					/* Turn all visible boxes off */
					/* Get all boxes that are not hidden and are on */
					const boxes = $(`#${this.id} .searchable-item:not(".is-hidden") .searchable-item-input[type="checkbox"]:checked`);
					/* Now remove them from this.values */
					for (let i = 0; i < boxes.length; i++) {
						/* Check if value is in this.values */
						const index = this.selected.indexOf(boxes[i].value);
						/* If value is in this.values, remove it with splice */
						if (index !== -1) {
							this.selected.splice(index, 1);
						}
					}
				}
				this.$emit('change', this.selected);
			}
		}
	});
})();
